import React, { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  IconButton,
  Box
} from '@mui/material';
import {
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  GavelOutlined as LawIcon
} from '@mui/icons-material';

interface LawEntry {
  id: string;
  title: string;
  category: string;
  summary: string;
  details: string;
  lastUpdated: string;
}

const mockLaws: LawEntry[] = [
  {
    id: '1',
    title: 'Compulsory Education Law',
    category: 'Attendance',
    summary: 'Requires children between ages 6-18 to attend school',
    details: 'Details about compulsory education requirements...',
    lastUpdated: '2023-07-15'
  },
  {
    id: '2',
    title: 'Student Records Privacy',
    category: 'Privacy',
    summary: 'Guidelines for handling student information under FERPA',
    details: 'Detailed FERPA compliance requirements...',
    lastUpdated: '2023-08-01'
  }
];

export const LawsDatabase: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleToggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const filteredLaws = mockLaws.filter(law =>
    law.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    law.summary.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Education Laws & Policies
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search laws and policies..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <List>
        {filteredLaws.map((law) => (
          <Box key={law.id}>
            <ListItem
              button
              onClick={() => handleToggleExpand(law.id)}
              sx={{ bgcolor: 'background.paper', mb: 1, borderRadius: 1 }}
            >
              <ListItemIcon>
                <LawIcon />
              </ListItemIcon>
              <ListItemText
                primary={law.title}
                secondary={law.summary}
              />
              <IconButton edge="end">
                {expandedId === law.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </ListItem>
            <Collapse in={expandedId === law.id} timeout="auto" unmountOnExit>
              <Box sx={{ p: 3, bgcolor: 'action.hover', borderRadius: 1, mb: 2 }}>
                <Typography variant="body1" paragraph>
                  {law.details}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Last updated: {law.lastUpdated}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        ))}
      </List>
    </Paper>
  );
};